// extracted by mini-css-extract-plugin
export default {"button":"Form-Button__button--BXHed","iconOnly":"Form-Button__iconOnly--q6VWA","hidden":"Form-Button__hidden--F_1Jt","fullWidth":"Form-Button__fullWidth--UPN4E"};